import React from 'react';
import { MailIcon, InstagramIcon, GlobeIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-ink border-t border-white/10" data-id="element-63" data-mp="3gfivmltl4hfp">
      <div className="mx-auto max-w-4xl px-5 py-14 text-center pt-[28px]" data-id="element-64" data-mp="3gh3q6bfwg0dk">
        <p className="font-display text-xl font-black text-white" data-id="element-65" data-mp="32pfgeet4hnzr">
          MegaPack Universitario Elite<span className="align-super text-xs" data-id="element-66" data-mp="36pza18ehm9h5">™</span>
        </p>
        <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-white/60" data-id="element-67" data-mp="3uesani6215i3">
          El sistema de método y rendimiento académico N°1 para universitarios de Argentina. Porque
          estudiar mucho no debería costarte otro año de carrera.
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-white/70" data-id="element-68" data-mp="3lgon6gbidynn">
          <a href="mailto:soporte.sigmasmart@gmail.com" className="inline-flex items-center gap-2 transition-colors hover:text-gold" data-id="element-69" data-mp="29zgl41oc4umn">
            <MailIcon className="h-4 w-4 text-verde-soft" data-id="element-70" data-mp="2ezb9nykn184j" /> soporte.sigmasmart@gmail.com
          </a>
          <a href="#" className="inline-flex items-center gap-2 transition-colors hover:text-gold" data-id="element-71" data-mp="3laljxq66apz8">
            <InstagramIcon className="h-4 w-4 text-verde-soft" data-id="element-72" data-mp="3gbr0cm0dsxe2" /> @sigmasmartoficial
          </a>
          <a href="#" className="inline-flex items-center gap-2 transition-colors hover:text-gold" data-id="element-73" data-mp="3v8rko4g8tq2i">
            <GlobeIcon className="h-4 w-4 text-verde-soft" data-id="element-74" data-mp="3q7u0xnfl4nyw" /> www.sigmasmart.store
          </a>
        </div>

        <p className="mt-4 font-display text-base italic text-gold" data-id="element-75" data-mp="81fojswysm2m">
          “El próximo parcial puede ser diferente.” 🎓
        </p>

        <div className="mt-8 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-white/40" data-id="element-76" data-mp="322zr2mj94xe">
          <a href="#" className="transition-colors hover:text-white/70" data-id="element-77" data-mp="ctqogvrpg7v6">Términos y condiciones</a>
          <span data-id="element-78" data-mp="cw36f8xgqi88">·</span>
          <a href="#" className="transition-colors hover:text-white/70" data-id="element-79" data-mp="qt067zvk7a19">Política de privacidad</a>
          <span data-id="element-80" data-mp="msg7wsz920dj">·</span>
          <a href="#" className="transition-colors hover:text-white/70" data-id="element-81" data-mp="msy45plwwelg">Soporte</a>
        </div>

        <p className="mt-8 text-xs leading-relaxed text-white/35" data-id="element-82" data-mp="tw5wy2alzikm">
          © 2026 MegaPack Universitario Elite™ — Todos los derechos reservados. Prohibida la
          reproducción y redistribución sin autorización expresa.
        </p>
      </div>
    </footer>;
}